import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Card from '../../../../components/Card/Card';
import getAcceptanceToDay from '../../../../thunks/coilovers/acceptance/getAcceptanceToDay';
import AcceptanceTable from './AcceptanceTable';

const containerClassName = 'mb-[30px]';
const tableContainerClassName = 'overflow-auto';

const AcceptanceToDay = ({ onDelivered }) => {
  const dispatch = useDispatch();
  const {
    getAcceptanceToDay: {
      loading, data
    }
  } = useSelector((state) => ({
    application: state?.application,
    getAcceptanceToDay: state?.getAcceptanceToDay
  }), shallowEqual);

  useEffect(() => {
    if (!data?.length) {
      dispatch(getAcceptanceToDay());
    }
  }, []);

  return (
    <Card
      showHeader
      headerTitle="Today Expected"
      headerBordered={false}
      footerBordered={false}
      styleContainer={containerClassName}
    >
      <div className={tableContainerClassName}>
        <AcceptanceTable
          data={data}
          loading={loading}
          onDelivered={onDelivered}
        />
      </div>
    </Card>
  );
};

AcceptanceToDay.propTypes = {
  onDelivered: PropTypes.func
};

AcceptanceToDay.defaultProps = {
  onDelivered: () => {}
};

export default AcceptanceToDay;
